module.exports = __webpack_public_path__ + "static/media/los-angeles-pierce-college-logo-vector.7ea5c60c.png";